import { actions as mainActions } from '../config/reduxIndex';

export const types = {
	SET_DEFAULT: 'ROUTING/SET_DEFAULT',
	SET_ATTRIBUTE_BY_OBJ: 'ROUTING/SET_ATTRIBUTE_BY_OBJ'
}

const defaultState = {
	redirect: '/'
}

export default (state = defaultState, action) => {
	switch(action.type) {
		case types.SET_DEFAULT:
			return defaultState;
		case types.SET_ATTRIBUTE_BY_OBJ:
			return Object.assign({}, state, action.obj);
		default:
			return state;
	}
}

export const actions = {
	setDefault: () => {
		return {type: types.SET_DEFAULT};
	},
	setAttributeByObj: (obj) => {
		return {type: types.SET_ATTRIBUTE_BY_OBJ, obj};
	},
	setRoute: (route) => {
		return { 
			type: types.SET_ATTRIBUTE_BY_OBJ, 
			obj:{
				redirect: route
			} 
		}
	},
	routeTrigger: (routeName) => {
		return (dispatch) => {
			let route = '/';
			switch(routeName) {
				case '':
					return dispatch(mainActions.login.logout())
				default:
					route = '/' + routeName + '/';
					return dispatch(actions.setRoute(route));
			}
		}
	}
}   


// WEBPACK FOOTER //
// ./src/redux/routing.js